import { Joystick } from 'lucide-react';
import useConnectionIndicator from '../../hooks/use-connection-indicator';
import Indicator from '../components/indicator';

function ConnectionIndicator() {
  const { isJoystickActive } = useConnectionIndicator();

  return (
    <Indicator
      text={isJoystickActive ? 'Соединение с джойстиком установленно!' : 'Нет соединения с джойстиком!'}
      icon={<Joystick size={20} />}
      isActive={isJoystickActive}
      style={{ borderRadius: 8, padding: 8 }}
    />
  );
}

export default ConnectionIndicator;
